/**
* Copyright by: 

* by ESS-Ehrhardt Software Solutions & Service GmbH
* Basselscheider Str. 55
* D-56281 Emmelshausen
* +49 (0) 67 42 / 87 27 0
* info@epg.com
*/

import { faInfoSquare, IconDefinition } from '@fortawesome/pro-regular-svg-icons';
import { EPGImageSliderItem } from '../../../app/shared/epg-image-slider/epg-image-slider.component';
import { getImageSliderFromTaskDatum } from '../../../app/shared/functions';
import { TaskDataImage } from '../../../models/task.model';
import {
  LocationModel,
  RecordBaseModel,
  WorkflowItemSubtype,
  WorkflowItemType
} from '../record-base.model';

export interface FromDataElement {
  value: { type: { value: string }; text: { value: string }; value: TaskDataImage };
}

export class InfoRecord extends RecordBaseModel {
  itemIcon: IconDefinition = faInfoSquare;
  itemData?: InfoRecordData;

  constructor(itemName: string, geolocation?: LocationModel, timestamp?: string) {
    super(itemName, WorkflowItemType.FORM, WorkflowItemSubtype.INFO, geolocation, timestamp);
  }

  fromJson(json: any): InfoRecord | undefined {
    if (!json) return;
    let record = new InfoRecord(
      json.itemName.value,
      LocationModel.fromJson(json.geolocation),
      json.timestamp?.value
    );
    let infoRecordData = Object.create(InfoRecordData.prototype);
    record.itemData = infoRecordData.fromJson(json);

    return record;
  }
}

export class InfoRecordData {
  text: string;
  image?: EPGImageSliderItem;

  constructor(text: string, image?: EPGImageSliderItem) {
    this.text = text;
    this.image = image;
  }

  fromJson(json: any): InfoRecordData | undefined {
    const formData = json.formData.value ?? [];
    let text = '';
    let image: EPGImageSliderItem | undefined;
    formData.forEach((element: FromDataElement) => {
      if (element.value.type.value === 'TEXT') {
        text = element.value.text.value;
      }
      if (element.value.type.value === 'IMAGE') {
        image = getImageSliderFromTaskDatum(element.value.value);
      }
    });
    return new InfoRecordData(text, image);
  }
}
